module.exports = __webpack_public_path__ + "media/34.4b66f200.mp3";